/**
 * 애플리케이션 실행 환경 분기.
 *
 * Vite의 `import.meta.env.MODE`(빌드 모드)에 의존하지 않고, 명시적인
 * `VITE_APP_ENV` 환경변수로 서비스 환경을 구분한다.
 *
 * 환경별 주입 위치:
 * - `local`       → `.env.local`        (로컬 개발 `pnpm dev`)
 * - `development` → `.env.development`  (dev 배포 `pnpm build:dev`)
 * - `production`  → `.env.production`   (prod 배포 `pnpm build`)
 *
 * 값이 없으면 가장 안전한 `local`로 폴백한다.
 */
export type AppEnv = 'local' | 'development' | 'production';

export const APP_ENV: AppEnv = import.meta.env.VITE_APP_ENV ?? 'local';

export const isProduction = APP_ENV === 'production';
